import React from "react";
import defaultIllustration from "../../../../assets/img/noResultsSearch.svg";
 
const ResetFilterIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M4.16699 5H9.16699"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinecap="round"
    />
    <path
      d="M12.5 5H15.833"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinecap="round"
    />
    <path
      d="M7.5 10H15.8333"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinecap="round"
    />
    <path
      d="M4.16699 10H4.58366"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinecap="round"
    />
    <path
      d="M4.16699 15H10.8337"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinecap="round"
    />
    <path
      d="M14.167 15H15.8337"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinecap="round"
    />
    <circle
      cx="10.8337"
      cy="5"
      r="1.66667"
      stroke="currentColor"
      strokeWidth="1.75"
    />
    <circle
      cx="5.83366"
      cy="10"
      r="1.66667"
      stroke="currentColor"
      strokeWidth="1.75"
    />
    <circle
      cx="12.5007"
      cy="15"
      r="1.66667"
      stroke="currentColor"
      strokeWidth="1.75"
    />
  </svg>
);
 
const QueryEmptyState = ({
  title = "No matches found",
  message,
  illustration = defaultIllustration,
  alt = "No matches found",
  actionLabel = "Reset Filter",
  onAction,
  searchQuery = "",
  talentType = "",
}) => {
  const safeIllustration = illustration || defaultIllustration;
  const safeTitle = title || "No matches found";
  const safeMessage = message ||
    (searchQuery && talentType
      ? `We couldn't find any ${talentType} talent matching your search for ${searchQuery}`
      : searchQuery
      ? `We couldn't find any talent matching your search for ${searchQuery}`
      : "We couldn't find any talent matching your filter result");
 
  const handleActionClick = () => {
    try {
      if (onAction) {
        onAction();
      }
    } catch (error) {
      console.error("Failed to run empty state action:", error);
    }
  };
 
  return (
    <div className="qp-no-results-state">
      <img
        className="qp-no-results-illustration"
        src={safeIllustration}
        alt={alt}
      />
 
      <div className="qp-no-results-copy">
        <h3 className="qp-no-results-title">{safeTitle}</h3>
        <p className="qp-no-results">{safeMessage}</p>
      </div>
 
      {onAction && (
        <button
          type="button"
          className="qp-no-results-action"
          onClick={handleActionClick}
        >
          <ResetFilterIcon />
          <span>{actionLabel}</span>
        </button>
      )}
    </div>
  );
};
 
export default QueryEmptyState;
 